import logo from "../../../images/Vector.png";
import "./Header.css";

function Header() {
  return (
    <div className="header">
      <div className="container">
        <div className="header__container">
          <a href="/" className="header__logo-link">
            <img src={logo} width={86} alt="Logo" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Header;
